import Stomp from "webstomp-client";
import en from "../locale/en";

let activeClient = null;
let reconnectTimer = null;
let reconnectAttempts = 0;

function scheduleReconnect (callbacks, port) {
    if (reconnectTimer !== null) {
        return;
    }
    const backoff = Math.min(1000 * Math.pow(2, reconnectAttempts), 30000);
    const delay = backoff + Math.floor(Math.random() * 500);
    reconnectAttempts++;
    reconnectTimer = setTimeout(() => {
        reconnectTimer = null;
        connectContentService(callbacks, port);
    }, delay);
}

export function connectContentService (callbacks, port = "8083") {

    if (reconnectTimer !== null) {
        clearTimeout(reconnectTimer);
        reconnectTimer = null;
    }

    if (activeClient !== null) {
        try {
            activeClient.disconnect();
        } catch (e) {
            // already dead; nothing to release
        }
        activeClient = null;
    }

    var defaultCallbacks = {
        handleGameZipBuilt: null,
        handleGameZipUrlExpired: null
    };

    for (let key in callbacks) {
        if (Object.prototype.hasOwnProperty.call(callbacks, key)) {
            defaultCallbacks[key] = callbacks[key];
        }
    }

    let stompClient = contentServiceSocket("ws", port);
    activeClient = stompClient;

    stompClient.connect(
        {},
        () => {
            console.log("Connecting to Content Service WS");
            reconnectAttempts = 0;
            if(window.java !== null && window.java !== undefined) {
                window.java.clearErrorAlert();
            }

            stompClient.subscribe("/topic/wizard/gameZipBuilt", (tick) => {
                if (defaultCallbacks.handleGameZipBuilt) {
                    var response = JSON.parse(tick.body);
                    defaultCallbacks.handleGameZipBuilt(response);
                }
            });

            stompClient.subscribe("/topic/wizard/gameZipUrlExpired", (tick) => {
                if (defaultCallbacks.handleGameZipUrlExpired) {
                    var response = JSON.parse(tick.body);
                    defaultCallbacks.handleGameZipUrlExpired(response);
                }
            });
    
        },
        (error) => {
            if (stompClient !== activeClient) {
                return;
            }
            console.log("Error Connecting to Content Service WS: " + error);
            if(window.java !== null && window.java !== undefined) {
                window.java.errorAlert(`Error ${error.code}: Content Service Connection lost. Please check your network connection.`);
            }
            activeClient = null;
            scheduleReconnect(callbacks, port);
        }
    );

    return stompClient;
}

function contentServiceSocket (endpoint, port = "8083") {
    let _port = port;

    if(typeof port !== "string"){
        _port = "8083";
    }

    let contentServiceIP = "localhost";
    if (en && en.app && en.app.contentServiceIP) {
        contentServiceIP = en.app.contentServiceIP;
    }

    let stompClient = "";
    if (contentServiceIP == "localhost") {
        stompClient = Stomp.client(`ws://${contentServiceIP}:${_port}/` + endpoint);
    } else {
        stompClient = Stomp.client(`wss://${contentServiceIP}/` + endpoint);
    }
    
    stompClient.heartbeat.outgoing = 1000;
    stompClient.heartbeat.incoming = 1000;
    stompClient.debug = function() {};

    return stompClient;
}